<template>
  <button
    :class="b()"
    v-bind="$attrs"
    type="button"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  // type Setup = {};
  // type Data = {};

  /**
   * Renders a menu icon button.
   */
  export default defineComponent({
    name: 'c-main-navigation-icon-button',

    inheritAttrs: false,

    // components: {},

    // props: {},
    // emits: [],

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .c-main-navigation-icon-button {
    height: 100%;
    width: 4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--theme-color-grayscale--1000);
    cursor: pointer;

    @include mixins.media(sm) {
      width: 5rem;
    }
  }
</style>
